import { InjectionKey } from "vue";
import { RoleDtoExtended } from "./UserModalMixin";
export type activeContainerRolesType = (code: string) => RoleDtoExtended[];
export const activeContainerRolesInjectKey = Symbol() as InjectionKey<activeContainerRolesType>;
export type implicitContainerRolesType = (code: string) => RoleDtoExtended[];
export const implicitContainerRolesInjectKey = Symbol() as InjectionKey<implicitContainerRolesType>;
export type possibleContainerRolesType = (code: string) => RoleDtoExtended[];
export const possibleContainerRolesInjectKey = Symbol() as InjectionKey<possibleContainerRolesType>;
export type deleteContainerRoleNameType = (code: string, roleName: string) => Promise<void>;
export const deleteContainerRoleNameInjectKey = Symbol() as InjectionKey<deleteContainerRoleNameType>;
export type getContainerLabelType = (code: string) => string | null | undefined;
export const getContainerLabelInjectKey = Symbol() as InjectionKey<getContainerLabelType>;
export type getRoleDisplayLabelType = (code: string, roleName: string) => string | null | undefined;
export const getRoleDisplayLabelInjectKey = Symbol() as InjectionKey<getRoleDisplayLabelType>;
export type addContainerRoleNameType = (code: string, roleName: string) => Promise<void>;
export const addContainerRoleNameInjectKey = Symbol() as InjectionKey<addContainerRoleNameType>;
export type setContainerRoleNamesType = (code: string, roleNames: string[]) => Promise<void>;
export const setContainerRoleNamesInjectKey = Symbol() as InjectionKey<setContainerRoleNamesType>;
